import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],

    filters: {
      requiredInvoice: false,
      requiredClaim: false,
      urgent: false,
      requiredContinuation: false,
      requiredQuotation: false,
    },
    statusFilter: null,

    searchFields: [
      { key: "index", name: "global:service.index" },
      { key: "status.name", name: "global:service.status" },
    ],
    selectedSearchFields: ["index", "status.name"],
    dictionaryFields: [
      "tasksDictionary",
      "problemDescriptionsDictionary",
      "additionalInfo",
    ],
    url: "service",
  },
};

const serviceReducer = createSlice({
  name: "serviceReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    updateTableFilters: (state, { payload }) => {
      state.table.filters = { ...state.table.filters, ...payload };
    },
    clearRegistry: () => initialState,
    updateStatusFilter(state, action) {
      state.table.statusFilter = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
  updateTableFilters,
  updateStatusFilter,
} = serviceReducer.actions;

export default serviceReducer.reducer;
